<div class="filters_view_bg" [hidden]="!searchDropDownToggle" (click)="searchDropDownToggle = false"></div>
<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Calendar</h4>
                    </div>
                </div>


                <div class="card">
                    <div class="card-body">
                        <div class="mb-2" *ngIf="role === 'SuperAdmin'">
                            <button class="btn btn-primary" (click)="searchDropDownToggle = !searchDropDownToggle">
                                Filter
                            </button>
                            <div class="searchDropdown" [hidden]="!searchDropDownToggle" style="z-index: 51;">
                                <form [formGroup]="searchForm" autocomplete="off" (ngSubmit)="onSubmit()">

                                    <div  class="dropdownFields">
                                        <label>Employees</label>
                                        <ng-select [multiple]="false" formControlName="EMPLOYEE_ID_IN" placeholder="Employees" appendTo="body">
                                            <ng-option *ngFor="let item of employeeLists" [value]="item.id">{{item.name}}</ng-option>
                                        </ng-select>
                                    </div>
                                    
                                    <div class="advance-icon">
                                        <button class="btn reset-btn btn-cancel" type="button" (click)="onReset()">Reset</button>
                                        <button class="btn btn-primary ms-1" type="submit">Search</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="color-container">
                            <div class="color-container-wrapper" *ngFor="let item of colorsContainerData">
                                <div class="color-box" [ngStyle]="{background: item.colorCode}"></div>
                                <p class="color-title">{{item.title}}</p>
                            </div>
                        </div>
                        <full-calendar *ngIf='calendarVisible()' [options]='calendarOptions()'>
                            <ng-template #eventContent let-arg>
                              <!-- <b>{{ !arg.event.classNames.includes('holiday') && !arg.event.classNames.includes('absent') && !arg.event.classNames.includes('leave') ? arg.timeText : '' }}</b> -->
                              <i>{{ arg.event.title }}</i>
                            </ng-template>
                        </full-calendar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add Event modal -->
<!-- <p-dialog header="Add Event" [modal]="true" [(visible)]="addCalenderDetailPopup" [style]="{ width: '40rem' }">
  <form #CalendarForm="ngForm" (ngSubmit)="submit()">
  <div class="row">
      <div class="col-lg-12 col-sm-12 col-12">
          <div class="form-group d-flex checkboxContainer">
              <label>All Day Event</label>
              <input type="checkbox" class="checkboxInput" name="allDayEvent" [(ngModel)]="allDayEvent" (change)="selectAllDayEvent($event)">
          </div>
      </div>
      <div class="col-lg-6 col-sm-6 col-12">
          <div class="form-group required">
              <label>Please enter a new title for your event</label>
              <input type="text" name="eventTitle" [(ngModel)]="eventTitle">
          </div>
      </div>
  </div>    
  <div class="row" *ngIf="!allDayEvent">
    <div class="col-lg-6 col-sm-6 col-12">
        <div class="form-group required">
            <label>Start Time</label>
            <p-calendar 
            inputId="calendar-timeonly"
            name="startTime" 
            appendTo="body"
            [(ngModel)]="selectedStartTime"
            (onSelect)="selectTime($event,'startTime')"
            [timeOnly]="true" />
        </div>
    </div>
    <div class="col-lg-6 col-sm-6 col-12">
      <div class="form-group required">
          <label>End Time</label>
          <p-calendar 
            inputId="calendar-timeonly"
            name="endTime"  
            appendTo="body"
            [(ngModel)]="selectedEndTime"
            (onSelect)="selectTime($event,'endTime')"
            [timeOnly]="true" />
      </div>
  </div>
  </div>
  <div class="row mt-3">
      <div class="col-lg-12 align-right">
          <button class="btn btn-submit me-2" type="submit" >Submit</button>
          <a (click)="addCalenderDetailPopup = false" class="btn btn-cancel ">Cancel</a>
      </div>
  </div>
</form>
</p-dialog> -->

<!-- Delete event modal -->
<!-- <p-dialog header="Delete Event" [modal]="true" [(visible)]="deleteCalenderDetailPopup" [style]="{ width: '30rem' }">
  <form #DeleteCalendarForm="ngForm" (ngSubmit)="deleteCalendar()">
  <div class="row">
      <div class="col-lg-12 col-sm-12 col-12">
          <div class="form-group d-flex checkboxContainer">
              <p>Are you sure you want to delete this event {{clickInfo?.event?.title}}?</p>
          </div>
      </div>
  </div>   
  <div class="row mt-3">
      <div class="col-lg-12 align-right">
          <button class="btn btn-submit me-2" type="submit" >Yes</button>
          <a (click)="deleteCalenderDetailPopup = false" class="btn btn-cancel ">No</a>
      </div>
  </div>
</form>
</p-dialog> -->